import React from "react";
import clsx from "clsx";
import { Box } from "@curves/ui-base";
import { Grid } from "@mui/material";

const LabelAddon = ({ required, children, ...props }) => {
	return (
		<React.Fragment>
			<Box component="label" {...props}>
				{required && (
					<Box component="span" className="text-error mr-1">
						*
					</Box>
				)}
				{children}
			</Box>
		</React.Fragment>
	);
};

// 單欄 Row
export const FieldRow = ({ label, labelProps = {}, children, className, items = [2, 10], alignLabel = "right", required = false }) => {
	const alignLabelClass = ["right", "left"].includes(alignLabel) ? `text-${alignLabel}` : "text-right";
	return (
		<React.Fragment>
			<Grid item xs={items[0]} className={clsx("field-label", alignLabelClass, className)}>
				{label && (
					<LabelAddon required={required} {...labelProps}>
						{label}
					</LabelAddon>
				)}
			</Grid>
			<Grid item xs={items[1]} className={clsx("field-content", className)}>
				{React.isValidElement(children) && React.cloneElement(children, { required })}
			</Grid>
		</React.Fragment>
	);
};

// 多欄 Row
export const FieldGroup = ({ label, children, className, items = [2, 10], required, spacing: spacingProps = 3, ...props }) => {
	return (
		<Grid {...props} container spacing={3} className={clsx("field-group", className)}>
			<Grid item xs={items[0]} className="text-right field-label">
				{label && <LabelAddon required={required}>{label}</LabelAddon>}
			</Grid>
			<Grid item xs={items[1]}>
				<Grid container spacing={spacingProps} className="pr-5">
					{children}
				</Grid>
			</Grid>
		</Grid>
	);
};
